<app-navbar></app-navbar>

<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">

                <!-- Empty State -->
                <div class="text-center py-5" *ngIf="mainResponse.length == 0">
                    <div class="ultimate-3d-card p-5 mx-auto" style="max-width: 400px;">
                        <i class="fa-regular fa-image"
                            style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                        <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Album Data Found</h3>
                    </div>
                </div>

                <ng-container *ngIf="mainResponse.length != 0">

                    <!-- Breadcrumbs -->
                    <div class="mb-5 text-center" *ngIf="folders.length">
                        <div class="ultimate-3d-card d-inline-flex px-4 py-2 mx-auto" style="border-radius: 30px;">
                            <div class="d-flex flex-wrap align-items-center" style="font-weight: 600; font-size: 14px;">
                                <a style="cursor: pointer; color: #0d8b54; text-decoration: none; transition: color 0.3s ease;"
                                    class="hover-success" [routerLink]="['/photo-gallery']">Home</a>
                                <div class="mx-3" style="color: #94a3b8;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                                <ng-container *ngFor="let path of folders; let last = last; trackBy: trackByFn2">
                                    <ng-container *ngIf="!last">
                                        <a style="cursor: pointer; color: #0d8b54; text-decoration: none; transition: color 0.3s ease;"
                                            class="hover-success" (click)="Goto(path.id)">{{ path.name }}</a>
                                        <div class="mx-3" style="color: #94a3b8;">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round">
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="last">
                                        <div style="color: #0f4c3a; font-weight: 700;">
                                            {{ path.name }}
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <!-- Folders Section -->
                    <div class="mb-5" *ngIf="album.length != 0">
                        <div class="text-center mb-4">
                            <h2 class="ultimate-3d-title" style="font-size: 32px;">Folders</h2>
                            <div class="premium-header-divider mx-auto mt-2" style="width: 50px;"></div>
                        </div>
                        <div class="row g-4 justify-content-center">
                            <ng-container *ngFor="let album of album">
                                <div class="col-lg-4 col-md-6">
                                    <a [routerLink]="['/imageFolder', album.Id]" class="text-decoration-none">
                                        <div class="ultimate-3d-card gallery-3d-card h-100 d-flex flex-column">
                                            <div class="gallery-image-wrapper">
                                                <img [src]="album.ThumbnailLink ? TransformUrl(album.ThumbnailLink) : '/assets/img/school/logo.png'"
                                                    class="img-fluid" alt="Folder Thumbnail" (load)="onImageLoad()" />
                                            </div>
                                            <div
                                                class="gallery-content p-4 text-center flex-grow-1 d-flex align-items-center justify-content-center">
                                                <h4 class="gallery-title m-0">{{ album.Name }}</h4>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Files Section -->
                    <div class="mb-5" *ngIf="files.length != 0">
                        <div class="text-center mb-4">
                            <h2 class="ultimate-3d-title" style="font-size: 32px;">Images</h2>
                            <div class="premium-header-divider mx-auto mt-2" style="width: 50px;"></div>
                        </div>
                        <div class="row g-4 justify-content-center">
                            <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let image of files; let i = index">
                                <div class="ultimate-3d-card gallery-3d-card h-100 d-flex flex-column">
                                    <a href="javascript:void(0)" (click)="openLightbox(i, $event)"
                                        [title]="image.EnglishTitle || image.Title || image.Name || image.Id"
                                        class="text-decoration-none d-flex flex-column h-100">
                                        <div class="gallery-image-wrapper position-relative">
                                            <img [src]="image.ImageLink" [alt]="image.EnglishTitle || 'Gallery Image'"
                                                class="img-fluid w-100 h-100 object-fit-cover" />
                                            <div class="hover-overlay-reference d-flex align-items-center justify-content-center position-absolute top-0 start-0 w-100 h-100"
                                                style="background: rgba(15, 76, 58, 0.4); opacity: 0; transition: opacity 0.3s ease;">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                                    viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round">
                                                    <circle cx="11" cy="11" r="8"></circle>
                                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                    <line x1="11" y1="8" x2="11" y2="14"></line>
                                                    <line x1="8" y1="11" x2="14" y2="11"></line>
                                                </svg>
                                            </div>
                                        </div>
                                        <div
                                            class="gallery-content p-3 text-center flex-grow-1 d-flex align-items-center justify-content-center">
                                            <p class="m-0 text-truncate"
                                                style="color: #0f4c3a; font-weight: 700; font-size: 14px; width: 100%;">
                                                {{ image.EnglishTitle || image.Title || image.Name || 'Image' }}
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>

            </div>
        </div>
    </div>
</section>



<!-- Lightbox Modal -->
<div class="custom-lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
    <div class="lightbox-overlay"></div>
    <div class="lightbox-content" (click)="$event.stopPropagation()">
        <button class="lightbox-close" (click)="closeLightbox()">&times;</button>
        <button class="lightbox-prev" (click)="prevImage($event)" *ngIf="files.length > 1">&#10094;</button>

        <div class="lightbox-image-wrapper">
            <img [src]="files[currentImageIndex]?.ImageLink" class="lightbox-img"
                [alt]="files[currentImageIndex]?.EnglishTitle || 'Gallery Image'" />
            <div class="lightbox-watermark-counter" style="background: rgba(13, 139, 84, 0.8);">
                {{ currentImageIndex + 1 }} / {{ files.length }}
            </div>
            <div class="lightbox-caption"
                *ngIf="files[currentImageIndex]?.EnglishTitle || files[currentImageIndex]?.Title || files[currentImageIndex]?.Name"
                style="background: rgba(15, 76, 58, 0.8);">
                {{ files[currentImageIndex]?.EnglishTitle || files[currentImageIndex]?.Title ||
                files[currentImageIndex]?.Name }}
            </div>
        </div>

        <button class="lightbox-next" (click)="nextImage($event)" *ngIf="files.length > 1">&#10095;</button>
    </div>
</div>